// Action types for fetching orders
export const FETCH_BATCH_ORDERS_COUNT_REQUEST = 'FETCH_BATCH_ORDERS_COUNT_REQUEST';
export const FETCH_BATCH_ORDERS_COUNT_SUCCESS = 'FETCH_BATCH_ORDERS_COUNT_SUCCESS';
export const FETCH_BATCH_ORDERS_COUNT_FAILURE = 'FETCH_BATCH_ORDERS_COUNT_FAILURE';
export const FETCH_BATCH_ORDERS_COUNT_REST = 'FETCH_BATCH_ORDERS_COUNT_REST';
// Fetch data actions
export const fetchBatchOrdersCountRequest = (payload) => ({
    type: FETCH_BATCH_ORDERS_COUNT_REQUEST,
    payload,
});
export const fetchBatchOrdersCountSuccess = (payload) => ({
    type: FETCH_BATCH_ORDERS_COUNT_SUCCESS,
    payload,
});
export const fetchBatchOrdersCountFailure = (error) => ({
    type: FETCH_BATCH_ORDERS_COUNT_FAILURE,
    payload: error,
});
export const fetchBatchOrdersCountRest = () => ({
    type: FETCH_BATCH_ORDERS_COUNT_REST,
});
